module.exports = __webpack_public_path__ + "img/role4.c5f79c09.png";